export class AppError extends Error {
  public readonly status?: number;
  public readonly method?: string;
  public readonly url?: string;
  public readonly correlationId?: string;
  public readonly responsePayload?: unknown;
  public readonly source?: string;

  constructor(
    message: string,
    status?: number,
    metadata?: {
      method?: string;
      url?: string;
      correlationId?: string;
      responsePayload?: unknown;
      source?: string;
    }
  ) {
    super(message);
    this.name = 'AppError';
    this.status = status;
    this.method = metadata?.method;
    this.url = metadata?.url;
    this.correlationId = metadata?.correlationId;
    this.responsePayload = metadata?.responsePayload;
    this.source = metadata?.source;
  }
}

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }

  return 'Unexpected error occurred.';
}
